import { PositionAssignmentsRepository } from '@src/main/modules/reports/positionassignment/domain/position-assignments.repository';

import {
  PositionAssignmentReport,
  PositionAssignmentRequest,
} from '@src/main/modules/reports/shared/domain/report.interface';
import { PageResponse } from '@src/main/shared/infrastructure/entity/page.entity';

export const findPositionAssignByCriteria = async (
  repository: PositionAssignmentsRepository,
  criteria: PositionAssignmentRequest,
): Promise<PageResponse<PositionAssignmentReport>> => repository.findByCriteria(criteria);

export const findPositionAssignToExport = async (
  repository: PositionAssignmentsRepository,
  criteria: PositionAssignmentRequest,
): Promise<Set<PositionAssignmentReport>> => repository.findToExport(criteria);
